<template>
    <nav class="navbar is-primary" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <router-link class="navbar-item" to="/" exact>Leben bewegt e.V. {{ lang('Calendar') }}</router-link>

            <button class="navbar-burger burger" :class="{'is-active': menuShown}" @click="menuShown = !menuShown">
                <span></span>
                <span></span>
                <span></span>
            </button>
        </div>

        <div id="navbar-menu" class="navbar-menu" :class="{'is-active': menuShown}">
            <div class="navbar-start">
                <router-link class="navbar-item" :to="'/' + lang('stats')" exact v-if="$auth.check && $auth.user.role == 'Admin'">{{ lang('Statistics') }}</router-link>
                <router-link class="navbar-item" :to="'/' + lang('embed-codes')" exact v-if="$auth.check && $auth.user.role == 'Admin'">{{ lang('Embed Codes') }}</router-link>
                <router-link class="navbar-item" :to="'/' + lang('users')" exact v-if="$auth.check && $auth.user.role == 'Admin'">{{ lang('Users') }}</router-link>
            </div>
            <div class="navbar-end">
                <template v-if="$auth.check">
                    <router-link class="navbar-item" :to="'/' + lang('users') + '/' + lang('settings')">{{ lang('My Account') }}</router-link>
                    <a class="navbar-item" href="/logout">{{ lang('Logout') }}</a>
                </template>
                <template v-else>
                    <router-link class="navbar-item" :to="'/' + lang('login')">{{ lang('Login') }}</router-link>
                    <router-link class="navbar-item" :to="'/' + lang('register')">{{ lang('Register') }}</router-link>
                </template>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: "AppHeader",
    data() {
        return {
            menuShown: false
        };
    }
};
</script>
